/* eslint-disable import/prefer-default-export */
export const congenito = [
    {
        normal: `ECODOPPLERCARDIOGRAMA CONGÊNITO (NORMAL)

O exame foi realizado com qualidade técnica satisfatória.

MEDIDAS:  Peso --- Kg; Est. --- cm.
AE --- mm. Ao --- mm. DdVD --- mm. Esp.SIV --- mm. Esp.PPVE --- mm. DdVE --- mm. DsVE --- mm. 
FE (Teich) --- %. FC --- bpm.

ANÁLISE SEGMENTAR SEQUENCIAL:
O "situs" visceroatrial é "solitus" com levocardia e levoposição do ápex.
As conexões venosas sistêmica e pulmonar são normais.
Conexão atrioventricular tipo biventricular concordante. Há concordância ventrículo arterial.

SEPTOS:
Septo interatrial e interventricular íntegros. Ausência de “shunts” ao mapeamento de fluxo em cores.

CAVIDADES:
Átrios e ventrículos de dimensões e morfologia normais com vias de saída ventriculares pérvias.

FUNÇÃO VENTRICULAR:
Função contrátil dos ventrículos direito e esquerdo normais do ponto de vista global e segmentar.
FE (Simpson) --- %.

VALVAS:
Valvas cardíacas com mobilidade e abertura preservadas. Análise de fluxo ao mapeamento a cores sem alterações.

ARTÉRIA PULMONAR:
Localização anterior e a esquerda. Tronco e ramos pulmonares com calibres conservados.

AORTA:
Arco aórtico para a esquerda, com calibre conservado, sem anormalidades ao longo do seu
trajeto. Ausência de fluxo em topografia de canal arterial.

ARTÉRIAS CORONÁRIAS:
Origem e trajeto habitual das artérias coronárias direita e esquerda.

PERICÁRDIO:
Ausência de derrame ou espessamento pericárdico.

CONCLUSÃO:
ECOCARDIOGRAMA NORMAL
`,
    },

    {
        civ: `ECODOPPLERCARDIOGRAMA CONGÊNITO (CIV)

O exame foi realizado com qualidade técnica satisfatória.

MEDIDAS:  Peso --- Kg; Est. --- cm.
AE --- mm. Ao --- mm. DdVD --- mm. Esp.SIV --- mm. Esp.PPVE --- mm. DdVE --- mm. DsVE --- mm. 
FE (Teich) --- %. FC --- bpm.

ANÁLISE SEGMENTAR SEQUENCIAL:
O "situs" visceroatrial é "solitus" com levocardia e levoposição do ápex.
As conexões venosas sistêmica e pulmonar são normais.
Conexão atrioventricular tipo biventricular concordante. Há concordância ventrículo arterial.

SEPTOS:
Septo interatrial íntegro. Ausência de “shunts” ao mapeamento de fluxo em cores.
Septo interventricular com falha de continuidade e fluxo sistólico acelerado e turbulento com “shunt” VE-VD em região ---, compatível com comunicação interventricular medindo aproximadamente --- mm.

CAVIDADES:
Átrio direito encontra-se de dimensões --- [aumentadas / reduzidas].
Átrio esquerdo encontra-se de dimensões --- [aumentadas / reduzidas].
Ventrículo direito apresenta-se --- [dilatado / de dimensões normais], com miocárdio --- [hipertrófico / sem alterações]. Via de saída --- [com / sem] obstrução.
Ventrículo esquerdo apresenta-se --- [dilatado / de dimensões normais], com miocárdio --- [hipertrófico / sem alterações]. Via de saída --- [com / sem] obstrução.

FUNÇÃO VENTRICULAR:
Ventrículo direito com função --- [preservada / reduzida]. FAC --- %, TAPSE --- mm, s’ --- cm/s.
Ventrículo esquerdo com função contrátil --- [normal / reduzida] do ponto de vista global e segmentar. FE (Simpson)  --- %.

VALVAS:
Valvas cardíacas com mobilidade e abertura preservadas. Análise de fluxo ao mapeamento a cores sem alterações.

ARTÉRIA PULMONAR:
Localização anterior e a esquerda. Tronco e ramos pulmonares com calibres ---.
TP --- mm (---z), APD --- mm (---z) e APE --- mm (---z).

AORTA:
Arco aórtico para a esquerda, com calibre conservado, sem anormalidades ao longo do seu
trajeto. Ausência de fluxo em topografia de canal arterial.

ARTÉRIAS CORONÁRIAS:
Origem e trajeto habitual das artérias coronárias direita e esquerda.


PERICÁRDIO:
Ausência de derrame ou espessamento pericárdico.

DOPPLER:
Relação Qp/Qs: ---.
VTI de veia pulmonar --- cm, VTI VSVD --- cm e VTI VSVE --- cm.

CONCLUSÃO:
COMUNICAÇÃO INTERVENTRICULAR ---.
`,
    },
    {
        fop: `ECODOPPLERCARDIOGRAMA CONGÊNITO (FOP)

O exame foi realizado com qualidade técnica satisfatória.

MEDIDAS:  Peso --- Kg; Est. --- cm.
AE --- mm. Ao --- mm. DdVD --- mm. Esp.SIV --- mm. Esp.PPVE --- mm. DdVE --- mm. DsVE --- mm. 
FE (Teich) --- %. FC --- bpm.

ANÁLISE SEGMENTAR SEQUENCIAL:
O "situs" visceroatrial é "solitus" com levocardia e levoposição do ápex.
As conexões venosas sistêmica e pulmonar são normais.
Conexão atrioventricular tipo biventricular concordante. Há concordância ventrículo arterial.

SEPTOS:
Discreto fluxo com “shunt" predominante AE-AD em região central do septo interatrial, compatível com forame oval pérvio.
Septo interventricular íntegro. Ausência de “shunts” ao mapeamento de fluxo em cores.

CAVIDADES:
Átrios e ventrículos de dimensões e morfologia normais com vias de saída ventriculares pérvias.

FUNÇÃO VENTRICULAR:
Função contrátil dos ventrículos direito e esquerdo normais do ponto de vista global e segmentar.
FE (Simpson) --- %.

VALVAS:
Valvas cardíacas com mobilidade e abertura preservadas. Análise de fluxo ao mapeamento a cores sem alterações.

ARTÉRIA PULMONAR:
Localização anterior e a esquerda. Tronco e ramos pulmonares com calibres conservados.

AORTA:
Arco aórtico para a esquerda, com calibre conservado, sem anormalidades ao longo do seu
trajeto. Ausência de fluxo em topografia de canal arterial.

ARTÉRIAS CORONÁRIAS:
Origem e trajeto habitual das artérias coronárias direita e esquerda.

PERICÁRDIO:
Ausência de derrame ou espessamento pericárdico.

CONCLUSÃO:
FORAME OVAL PÉRVIO.
`,
    },
    {
        t4f: `ECODOPPLERCARDIOGRAMA CONGÊNITO (TETRALOGIA DE FALLOT)

O exame foi realizado com qualidade técnica satisfatória.

MEDIDAS:  Peso --- Kg; Est. --- cm.
AE --- mm. Ao --- mm. DdVD --- mm. Esp.SIV --- mm. Esp.PPVE --- mm. DdVE --- mm. DsVE --- mm. 
FE (Teich) --- %. FC --- bpm.

ANÁLISE SEGMENTAR SEQUENCIAL:
O "situs" visceroatrial é "solitus" com levocardia e levoposição do ápex.
As conexões venosas sistêmica e pulmonar são normais.
Conexão atrioventricular tipo biventricular concordante. Há concordância ventrículo arterial.

SEPTOS:
Septo interatrial ---. --- de “shunt” ao mapeamento de fluxo em cores.
Presença de comunicação ampla em septo interventricular (--- mm), com extensão para via de saída, apresentando fluxo bidirecional ao mapeamento a cores.

CAVIDADES:
Átrio direito encontra-se de dimensões --- [aumentadas / reduzidas].
Átrio esquerdo encontra-se de dimensões --- [aumentadas / reduzidas].
Ventrículo direito apresenta-se --- [dilatado / de dimensões normais], com miocárdio --- [hipertrófico / sem alterações]. Via de saída com estenose infundibular por desvio anterior do septo e obstrução predominante em região ---.
Ventrículo esquerdo apresenta-se --- [dilatado / de dimensões normais], com miocárdio --- [hipertrófico / sem alterações]. Via de saída --- [com / sem] obstrução.

FUNÇÃO VENTRICULAR:
Ventrículo direito com função --- [preservada / reduzida]. FAC --- %, TAPSE --- mm, s’ --- cm/s.
Ventrículo esquerdo com função contrátil --- [normal / reduzida] do ponto de vista global e segmentar. FE (Simpson)  --- %.

VALVAS:
Valva pulmonar ---, com fluxo sistólico acelerado e turbulento compatível com estenose pulmonar de grau ---, com GS máximo de --- mmHg e velocidade de --- cm/s. Anel VP --- mm (---z).
Valva aórtica trivalvulada, dextroposta e com “overriding” < 50%, abertura e mobilidade preservadas. 
As demais valvas cardíacas apresentam mobilidade e abertura preservadas. Análise de fluxo por mapeamento a cores sem alterações.

ARTÉRIA PULMONAR:
Localização anterior e a esquerda. Tronco e ramos pulmonares com calibres ---. 
TP --- mm (---z),  APD --- mm (---z) e APE --- (---z).

AORTA:
Arco aórtico para a ---, com calibre conservado, sem anormalidades ao longo do seu trajeto. Ausência de fluxo em topografia de canal arterial.

ARTÉRIAS CORONÁRIAS:
Origem e trajeto das artérias coronárias direita e esquerda ---.

PERICÁRDIO:
Ausência de derrame ou espessamento pericárdico.

CONCLUSÃO:
TETRALOGIA DE FALLOT
`,
    },
    {
        pca: `ECODOPPLERCARDIOGRAMA CONGÊNITO (PCA)

O exame foi realizado com qualidade técnica satisfatória.

MEDIDAS:  Peso --- Kg; Est. --- cm.
AE --- mm. Ao --- mm. DdVD --- mm. Esp.SIV --- mm. Esp.PPVE --- mm. DdVE --- mm. DsVE --- mm. 
FE (Teich) --- %. FC --- bpm.

ANÁLISE SEGMENTAR SEQUENCIAL:
O "situs" visceroatrial é "solitus" com levocardia e levoposição do ápex.
As conexões venosas sistêmica e pulmonar são normais.
Conexão atrioventricular tipo biventricular concordante. Há concordância ventrículo arterial.

SEPTOS:
Septo interatrial e interventricular íntegros. Ausência de “shunts” ao mapeamento de fluxo em cores.

CAVIDADES:
Átrio direito encontra-se de dimensões --- [aumentadas / reduzidas].
Átrio esquerdo encontra-se de dimensões --- [aumentadas / reduzidas].
Ventrículo direito apresenta-se --- [dilatado / de dimensões normais], com miocárdio --- [hipertrófico / sem alterações]. Via de saída --- [com / sem] obstrução.
Ventrículo esquerdo apresenta-se --- [dilatado / de dimensões normais], com miocárdio --- [hipertrófico / sem alterações]. Via de saída --- [com / sem] obstrução.

FUNÇÃO VENTRICULAR:
Ventrículo direito com função --- [preservada / reduzida]. FAC --- %, TAPSE --- mm, s’ --- cm/s.
Ventrículo esquerdo com função contrátil --- [normal / reduzida] do ponto de vista global e segmentar. FE (Simpson)  --- %.

VALVAS:
Valvas cardíacas com mobilidade e abertura preservadas. Análise de fluxo ao mapeamento a cores sem alterações.

ARTÉRIA PULMONAR:
Localização anterior e a esquerda. Tronco e ramos pulmonares com calibres ---.
TP --- mm (---z), APD --- mm (---z) e APE --- mm (---z).

AORTA:
Arco aórtico para a esquerda, com calibre conservado, sem anormalidades ao longo do seu
trajeto. Presença de fluxo contínuo em topografia de canal arterial com “shunt” Ao-TP, compatível com persistência do canal arterial que mede --- mm na extremidade aórtica, --- mm na extremidade pulmonar e com comprimento de --- mm. GS --- mmHg e velocidade máxima --- cm/s.

ARTÉRIAS CORONÁRIAS:
Origem e trajeto habitual das artérias coronárias direita e esquerda.

PERICÁRDIO:
Ausência de derrame ou espessamento pericárdico.

CONCLUSÃO:
PERSISTÊNCIA DO CANAL ARTERIAL ---.
`,
    },
    {
        cia: `ECODOPPLERCARDIOGRAMA CONGÊNITO (CIA)

O exame foi realizado com qualidade técnica satisfatória.

MEDIDAS:  Peso --- Kg; Est. --- cm.
AE --- mm. Ao --- mm. DdVD --- mm. Esp.SIV --- mm. Esp.PPVE --- mm. DdVE --- mm. DsVE --- mm. 
FE (Teich) --- %. FC --- bpm.

ANÁLISE SEGMENTAR SEQUENCIAL:
O "situs" visceroatrial é "solitus" com levocardia e levoposição do ápex.
As conexões venosas sistêmica e pulmonar são normais.
Conexão atrioventricular tipo biventricular concordante. Há concordância ventrículo arterial.

SEPTOS:
Presença de “shunt” com fluxo acelerado à direita do septo interatrial ---, compatível com comunicação interatrial tipo --- (--- mm).
Bordas: póstero-inferior (VCI) --- mm; posterossuperior (VCS) --- mm; ântero-inferior (VM) --- mm e anterossuperior (VAo) --- mm.
Septo interventricular íntegro. Ausência de “shunts” ao mapeamento de fluxo em cores.

CAVIDADES:
Átrio direito encontra-se de dimensões --- [aumentadas / reduzidas].
Átrio esquerdo encontra-se de dimensões --- [aumentadas / reduzidas].
Ventrículo direito apresenta-se --- [dilatado / de dimensões normais], com miocárdio --- [hipertrófico / sem alterações]. Via de saída --- [com / sem] obstrução.
Ventrículo esquerdo apresenta-se --- [dilatado / de dimensões normais], com miocárdio --- [hipertrófico / sem alterações]. Via de saída --- [com / sem] obstrução.

FUNÇÃO VENTRICULAR:
Ventrículo direito com função --- [preservada / reduzida]. FAC --- %, TAPSE --- mm, s’ --- cm/s.
Ventrículo esquerdo com função contrátil --- [normal / reduzida] do ponto de vista global e segmentar. FE (Simpson)  --- %.

VALVAS:
Valvas cardíacas com mobilidade e abertura preservadas. Análise de fluxo ao mapeamento a cores sem alterações.

ARTÉRIA PULMONAR:
Localização anterior e a esquerda. Tronco e ramos pulmonares com calibres conservados.

AORTA:
Arco aórtico para a esquerda, com calibre conservado, sem anormalidades ao longo do seu
trajeto. Ausência de fluxo em topografia de canal arterial.

ARTÉRIAS CORONÁRIAS:
Origem e trajeto habitual das artérias coronárias direita e esquerda.

PERICÁRDIO:
Ausência de derrame ou espessamento pericárdico.

DOPPLER:
Relação Qp/Qs: ---.
VTI de veia pulmonar --- cm, VTI VSVE --- cm e VTI VSVD --- cm.

CONCLUSÃO:
COMUNICAÇÃO INTERATRIAL TIPO ---.
`,
    },
    {
        tga: `ECODOPPLERCARDIOGRAMA CONGÊNITO (D-TGA)

O exame foi realizado com qualidade técnica satisfatória.

MEDIDAS:  Peso --- Kg; Est. --- cm.
AE --- mm. Ao --- mm. DdVD --- mm. Esp.SIV --- mm. Esp.PPVE --- mm. DdVE --- mm. DsVE --- mm. 
FE (Teich) --- %. FC --- bpm.

ANÁLISE SEGMENTAR SEQUENCIAL:
O "situs" visceroatrial é "solitus" com levocardia e levoposição do ápex.
As conexões venosas sistêmica e pulmonar são normais.
Conexão atrioventricular tipo biventricular concordante. Há discordância ventrículo arterial, com a aorta emergindo do ventrículo direito e a pulmonar do ventrículo esquerdo.

SEPTOS:
Presença de “shunt” com fluxo AE-AD pelo forame oval que encontra-se prévio e sem sinais de restrição ao fluxo.
Septo interventricular íntegro, ausência de “shunt” ao mapeamento de fluxo em cores.

Septo interventricular com falha de continuidade e fluxo sistólico acelerado e turbulento com “shunt” VE-VD em região ---, compatível com comunicação interventricular medindo aproximadamente --- mm.

CAVIDADES:
Átrio direito encontra-se de dimensões --- [aumentadas / reduzidas].
Átrio esquerdo encontra-se de dimensões --- [aumentadas / reduzidas].
Ventrículo direito apresenta-se --- [dilatado / de dimensões normais], com miocárdio --- [hipertrófico / sem alterações]. Via de saída --- [com / sem] obstrução.
Ventrículo esquerdo apresenta-se --- [dilatado / de dimensões normais], com miocárdio --- [hipertrófico / sem alterações]. Via de saída --- [com / sem] obstrução.

FUNÇÃO VENTRICULAR:
Ventrículo direito com função --- [preservada / reduzida]. FAC --- %, TAPSE --- mm, s’ --- cm/s.
Ventrículo esquerdo com função contrátil --- [normal / reduzida] do ponto de vista global e segmentar. FE (Simpson)  --- %.

VALVAS:
Valvas semilunares de disposição ---. Mantendo mobilidade e abertura ---.
As demais valvas cardíacas possuem mobilidade e abertura preservadas. Análise de fluxo ao mapeamento a cores sem alterações.

ARTÉRIA PULMONAR:
Localização posterior. Tronco e ramos pulmonares com calibres conservados.

AORTA:
Localização anterior, com arco aórtico para a esquerda e calibre conservado, sem anormalidades ao longo do seu trajeto.
--- [Presença/Ausência] de fluxo [contínuo] em topografia de canal arterial [com “shunt” Ao-TP, compatível com persistência do canal arterial que mede --- mm na extremidade aórtica, --- mm na extremidade pulmonar e com comprimento de --- mm. GS --- mmHg e velocidade máxima --- cm/s.]

ARTÉRIAS CORONÁRIAS:
Origem e trajeto das artérias coronárias direita e esquerda encontra-se ---.

PERICÁRDIO:
Ausência de derrame ou espessamento pericárdico.

CONCLUSÃO:
TRANSPOSIÇÃO DAS GRANDES ARTÉRIAS (D-TGA).
FORAME OVAL PÉRVIO NÃO RESTRITIVO.
`,
    },
    {
        dsavt: `ECODOPPLERCARDIOGRAMA CONGÊNITO (DSAV)

O exame foi realizado com qualidade técnica satisfatória.

MEDIDAS:  Peso --- Kg; Est. --- cm.
AE --- mm. Ao --- mm. DdVD --- mm. Esp.SIV --- mm. Esp.PPVE --- mm. DdVE --- mm. DsVE --- mm. 
FE (Teich) --- %. FC --- bpm.

ANÁLISE SEGMENTAR SEQUENCIAL:
O "situs" visceroatrial é "solitus" com levocardia e levoposição do ápex.
As conexões venosas sistêmica e pulmonar são normais.
Conexão atrioventricular comum tipo biventricular concordante. Há concordância ventrículo arterial.

SEPTOS:
Presença de fluxo bidirecional por análise de mapeamento a cores em septo interatrial próximo à valva AV comum, compatível com comunicação interatrial “Ostium Primum” (--- mm).
Fluxo bidirecional no topo do septo interventricular, compatível com comunicação interventricular de via de entrada (--- mm), por ausência do septo atrioventricular.

CAVIDADES:
Átrio direito encontra-se de dimensões --- [aumentadas / reduzidas].
Átrio esquerdo encontra-se de dimensões --- [aumentadas / reduzidas].
Ventrículo direito apresenta-se --- [dilatado / de dimensões normais], com miocárdio --- [hipertrófico / sem alterações]. Via de saída --- [com / sem] obstrução.
Ventrículo esquerdo apresenta-se --- [dilatado / de dimensões normais], com miocárdio --- [hipertrófico / sem alterações]. Presença de VSVE alongada “goose neck”, --- [com / sem] obstrução.

FUNÇÃO VENTRICULAR:
Ventrículo direito com função --- [preservada / reduzida]. FAC --- %, TAPSE --- mm, s’ --- cm/s, volume indexado do AD --- ml/m².
Ventrículo esquerdo com função contrátil --- [normal / reduzida] do ponto de vista global e segmentar. FE (Simpson)  --- %.

VALVAS:
Valva atrioventricular comum com abertura balanceada aos dois ventrículos, --- “straddling” de cordoalhas e inserção do folheto ponte anterior ---. Apresenta insuficiência valvar de grau ---, sem gradiente transvalvar significativo.
Valvas aórtica e pulmonar com mobilidade e abertura preservadas, análise de fluxo por mapeamento a cores sem alterações.

ARTÉRIA PULMONAR:
Localização anterior e a esquerda. Tronco e ramos pulmonares com calibres conservados.

AORTA:
Arco aórtico para a esquerda, com calibre conservado, sem anormalidades ao longo do seu
trajeto. Ausência de fluxo em topografia de canal arterial.

ARTÉRIAS CORONÁRIAS:
Origem e trajeto habitual das artérias coronárias direita e esquerda.

PERICÁRDIO:
Ausência de derrame ou espessamento pericárdico.

CONCLUSÃO:
DEFEITO DO SEPTO ATRIOVENTRICULAR TOTAL TIPO --- DE RASTELLI.
`,
    },
    {
        coao: `ECODOPPLERCARDIOGRAMA CONGÊNITO (COARCTAÇÃO DE AORTA)

O exame foi realizado com qualidade técnica satisfatória.

MEDIDAS:  Peso --- Kg; Est. --- cm.
AE --- mm. Ao --- mm. DdVD --- mm. Esp.SIV --- mm. Esp.PPVE --- mm. DdVE --- mm. DsVE --- mm. 
FE (Teich) --- %. FC --- bpm.

ANÁLISE SEGMENTAR SEQUENCIAL:
O "situs" visceroatrial é "solitus" com levocardia e levoposição do ápex.
As conexões venosas sistêmica e pulmonar são normais.
Conexão atrioventricular tipo biventricular concordante. Há concordância ventrículo arterial.

SEPTOS:
Septo interatrial e interventricular íntegros. Ausência de “shunts” ao mapeamento de fluxo em cores.

CAVIDADES:
Átrio direito encontra-se de dimensões --- [aumentadas / reduzidas].
Átrio esquerdo encontra-se de dimensões --- [aumentadas / reduzidas].
Ventrículo direito apresenta-se --- [dilatado / de dimensões normais], com miocárdio --- [hipertrófico / sem alterações]. Via de saída --- [com / sem] obstrução.
Ventrículo esquerdo apresenta-se --- [dilatado / de dimensões normais], com miocárdio --- [hipertrófico / sem alterações]. Via de saída --- [com / sem] obstrução.

FUNÇÃO VENTRICULAR:
Ventrículo direito com função --- [preservada / reduzida]. FAC --- %, TAPSE --- mm, s’ --- cm/s.
Ventrículo esquerdo com função contrátil --- [normal / reduzida] do ponto de vista global e segmentar. FE (Simpson)  --- %.

VALVAS:
Valvas cardíacas com mobilidade e abertura preservadas. Análise de fluxo ao mapeamento a cores sem alterações.
VA --- mm (---z), Raiz --- mm (---z) e JST --- mm (---z).

ARTÉRIA PULMONAR:
Localização anterior e a esquerda. Tronco e ramos pulmonares com calibres conservados.

AORTA:
Arco aórtico para a esquerda, com estreitamento em região de istmo compatível com coarctação. Fluxo acelerado e turbulento com GS máx de --- mmHg e velocidade de --- cm/s.
Ausência de fluxo em topografia de canal arterial.
Nota-se fluxo sisto-diastólico anterógrado em aorta abdominal “reforço diastólico”.
Ao ascendente --- mm (---z), transverso proximal --- mm (---z), transverso distal --- mm (---z), istmo --- mm (---z) e Ao descendente --- mm (---z).

ARTÉRIAS CORONÁRIAS:
Origem e trajeto habitual das artérias coronárias direita e esquerda.

PERICÁRDIO:
Ausência de derrame ou espessamento pericárdico.

CONCLUSÃO:
COARCTAÇÃO DE AORTA.
`,
    },
];